export default __webpack_public_path__ + "assets/e762a61945349628f5fa7b25323876ca.woff2";